import { render, staticRenderFns } from "./global-popups.vue?vue&type=template&id=e4911e8e&scoped=true"
import script from "./global-popups.vue?vue&type=script&lang=js"
export * from "./global-popups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4911e8e",
  null
  
)

export default component.exports